import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "footerFixed" };
const _hoisted_2 = {
    id: "all_wrapper",
    class: "help"
};
const _hoisted_3 = { class: "wrapper_1" };
const _hoisted_4 = { class: "inner" };
const _hoisted_5 = { class: "breadcrumb" };
const _hoisted_6 = ["innerHTML"];
const _hoisted_7 = { class: "bt_under_navi" };
const _hoisted_8 = {
    key: 1,
    class: "no_prev"
};
const _hoisted_9 = {
    key: 1,
    class: "no_next"
};
const _hoisted_10 = { class: "bt_under" };
const _hoisted_11 = { class: "b_max" };
import { Link } from '@inertiajs/inertia-vue3';
import headerVue from '@layout/header.vue';
import footerVue from '@layout/footer.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'help_detail',
    props: {
        common: {},
        help_detail: {}
    },
    setup(__props) {
        const props = __props;
        const getRoute = (id) => {
            return route('help.show', { id: id });
        };
        return (_ctx, _cache) => {
            var _a, _b, _c, _d, _e;
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(headerVue, {
                    common: props.common
                }, null, 8, ["common"]),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _cache[4] || (_cache[4] = _createElementVNode("h2", null, "ShareMentors ヘルプ", -1)),
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("ol", _hoisted_5, [
                                    _createElementVNode("li", null, [
                                        _createVNode(_unref(Link), { href: "/help" }, {
                                            default: _withCtx(() => _cache[0] || (_cache[0] = [
                                                _createTextVNode("ShareMentors ヘルプ")
                                            ])),
                                            _: 1,
                                            __: [0]
                                        })
                                    ]),
                                    _createElementVNode("li", null, _toDisplayString((_b = (_a = props.help_detail) === null || _a === void 0 ? void 0 : _a.title) !== null && _b !== void 0 ? _b : ''), 1)
                                ]),
                                _createElementVNode("div", {
                                    class: "w_box",
                                    innerHTML: (_c = props.help_detail) === null || _c === void 0 ? void 0 : _c.content
                                }, null, 8, _hoisted_6),
                                _createElementVNode("ul", _hoisted_7, [
                                    _createElementVNode("li", null, [
                                        ((_d = props.help_detail) === null || _d === void 0 ? void 0 : _d.prev_id)
                                            ? (_openBlock(), _createBlock(_unref(Link), {
                                                key: 0,
                                                href: getRoute(props.help_detail.prev_id),
                                                class: "prev"
                                            }, {
                                                default: _withCtx(() => _cache[1] || (_cache[1] = [
                                                    _createTextVNode(" 前へ ")
                                                ])),
                                                _: 1,
                                                __: [1]
                                            }, 8, ["href"]))
                                            : (_openBlock(), _createElementBlock("p", _hoisted_8, "前へ"))
                                    ]),
                                    _createElementVNode("li", null, [
                                        ((_e = props.help_detail) === null || _e === void 0 ? void 0 : _e.next_id)
                                            ? (_openBlock(), _createBlock(_unref(Link), {
                                                key: 0,
                                                href: getRoute(props.help_detail.next_id),
                                                class: "next"
                                            }, {
                                                default: _withCtx(() => _cache[2] || (_cache[2] = [
                                                    _createTextVNode(" 次へ ")
                                                ])),
                                                _: 1,
                                                __: [2]
                                            }, 8, ["href"]))
                                            : (_openBlock(), _createElementBlock("p", _hoisted_9, "次へ"))
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_10, [
                                    _createElementVNode("ul", null, [
                                        _createElementVNode("li", _hoisted_11, [
                                            _createVNode(_unref(Link), { href: "/help" }, {
                                                default: _withCtx(() => _cache[3] || (_cache[3] = [
                                                    _createTextVNode("一覧へ戻る")
                                                ])),
                                                _: 1,
                                                __: [3]
                                            })
                                        ])
                                    ])
                                ])
                            ])
                        ])
                    ]),
                    _createVNode(footerVue)
                ])
            ]));
        };
    }
});
